import { createColumnHelper } from '@tanstack/react-table';
import { SsoConnectionAddParametersDomain } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Toggle } from '@optimus-web/core';

const columnHelper = createColumnHelper<SsoConnectionAddParametersDomain>();

export const useSsoDomainColumns = ({
    onDomainChange,
}: {
    onDomainChange: (domain: string, enforceSingleSignOn: boolean) => void;
}) => [
    columnHelper.accessor('enforceSingleSignOn', {
        header: () => <LocalizedText textKey={TextKey.SsoRequired} />,
        cell: ({ getValue, row }) => (
            <Stack alignment="center" fill>
                <Toggle checked={getValue()} onChange={() => onDomainChange(row.original.domain, !getValue())} />
            </Stack>
        ),
        meta: {
            width: 150,
        },
    }),
    columnHelper.accessor('domain', {
        id: 'domain',
        header: () => <LocalizedText textKey={TextKey.SsoSetupDomainName} />,
        cell: ({ getValue }) => getValue(),
    }),
];
